var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',{staticStyle:{"height":"100%","padding":"10px"}},[_c('el-aside',{staticClass:"asideContent",attrs:{"width":_vm.asideWidth}},[_vm._t("aside")],2),_c('el-main',{staticClass:"mainContent"},[_vm._t("main")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }